import {get, writable} from "svelte/store";
import {deliveryStore} from "./orders-store.js";
import {screensStore} from "../core/screens-manager.js";

export const acceptPolicyStore = writable({}, (set) => {

    set({
        hideAcceptPolicy: false
    });

    return () => {}
});

const updateAcceptPolicyVisibility = (selectedOnsite, selectedDelivery, selectedPickup) => {

    const acceptPolicy = (M.docs || []).find(x => x.docType === 'privacy-policy')?.acceptPolicy || {};

    acceptPolicyStore.update(x => {

        if (selectedOnsite && acceptPolicy.hideForOnsite !== undefined) {
            x.hideAcceptPolicy = acceptPolicy.hideForOnsite === true;
        }
        else if (!selectedOnsite && !selectedDelivery && !selectedPickup && acceptPolicy.hideForOnsite !== undefined) {
            /// not onsite, not delivery, not pickup => onsite
            x.hideAcceptPolicy = acceptPolicy.hideForOnsite === true;
        }
        else if (selectedDelivery && acceptPolicy.hideForDelivery !== undefined) {
            x.hideAcceptPolicy = acceptPolicy.hideForDelivery === true;
        }
        else if (selectedPickup && acceptPolicy.hideForPickup !== undefined) {
            x.hideAcceptPolicy = acceptPolicy.hideForPickup === true;
        }
        else {
            x.hideAcceptPolicy = false;
        }

        return x;
    });
};

export const initPolicyStore = () => {

    deliveryStore.subscribe((x) => {
        updateAcceptPolicyVisibility(x.selectedOnsite, x.selectedDelivery, x.selectedPickup);
    });

    screensStore.subscribe((x, y) => {
        if (x.orderFormOpened) {
            const current = get(deliveryStore);
            updateAcceptPolicyVisibility(current.selectedOnsite, current.selectedDelivery, current.selectedPickup);
        }
    });
}

initPolicyStore();
